import { AnalyticsEvent, AnalyticsManager } from '@oy/analytics';
import { Button, ButtonWithIcon } from '@oy/uidesktop';
import { Link } from 'react-router-dom';
import { useTranslate } from 'src/hooks';

const InternationalRemitListActionButton = () => {
  const { getTranslation } = useTranslate();
  return (
    <div id="coachList5">
      <Link
        onClick={() => {
          AnalyticsManager.instance().track(AnalyticsEvent.inter_remit_create);
        }}
        to={'/disbursement/create-international-remittance-transaction'}
      >
        <ButtonWithIcon color={Button.Color.Primary} iconName="add">
          {getTranslation('common_createNewTransaction')}
        </ButtonWithIcon>
      </Link>
    </div>
  );
};

export default InternationalRemitListActionButton;
